// extracted by mini-css-extract-plugin
export default {"translate":"LanguageSwitcher_translate__9cCbc"};